import React, { MouseEvent } from 'react';
import styles from './stats-box.module.css';

export function formatDate(dateString: string): string {
  const date = new Date(dateString);
  return date.toUTCString();
}

/**
 * Birthdays are stored as a UTC date, and the AOTD birthday-priority window is
 * matched on the UTC month/day — so render them in UTC too. Reading them in
 * local time would show a different day than the one the priority hook fires on.
 */
export function formatBirthday(dateString?: string | null): string {
  if (!dateString) return "—";
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: "UTC",
  });
}

interface UserInfoProps {
  username: string;
  userEmoji: string;
  email: string;
  role: string;
  dateSigned: string;
  birthDate?: string | null;
  timesSigned: number;
  chatTokensUsed: number;
  permissions: number;
  onEditButtonClick: () => void;
}

class UserInfo extends React.Component<UserInfoProps> {
  handleButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
    this.props.onEditButtonClick();
  }



  render() {
    const { username,userEmoji, email, role, dateSigned, birthDate, timesSigned, chatTokensUsed, permissions } = this.props;

    return (
      <div className={styles.userInfo}>
        <div className={styles.infoBox}><strong>username:</strong> {userEmoji ? <span>{userEmoji}.{username}</span> : <span>{username}</span>}</div>
        <div className={styles.infoBox}><strong>email:</strong> {email}</div>
        <div className={styles.infoBox}><strong>role:</strong> {role}</div>
        <div className={styles.infoBox}><strong>date signed:</strong> {formatDate(dateSigned)}</div>
        <div className={styles.infoBox}><strong>birthday:</strong> {formatBirthday(birthDate)}</div>
        <div className={styles.infoBox}><strong>times signed:</strong> {timesSigned}</div>
        <div className={styles.infoBox}><strong>chat tokens:</strong> {chatTokensUsed}</div>
        <div className={styles.infoBox}><strong>permissions:</strong> {permissions}</div>
        <button className={styles.editButton} onClick={this.handleButtonClick}>edit</button>
      </div>
    );
  }
}
export default UserInfo;
